module.exports = __webpack_public_path__ + "img/coin.a777b7d6.png";